// eslint-disable-next-line func-names
window.loadSourcePoint = function () {
  console.log('Source point integration')
}
